import React from 'react';
import dayjs from 'dayjs';

import './print.css';
import requireAuth from '~components/hocs/requireAuth';
import { PrintableExportShell } from '~components/PrintableLayout';
import CDNAnalytics from '~features/CDNAnalytics/CDNAnalyticsPage';

function CDNAnalyticsExport() {
  React.useEffect(() => {
    document.title = `Prerender - CDN Analytics export PDF ${dayjs().format('YYYY-MM-DD')}`;
  }, []);

  return (
    <PrintableExportShell>
      <CDNAnalytics print />
    </PrintableExportShell>
  );
}

export default requireAuth(CDNAnalyticsExport);
